import http from '../utils/http'

const getAll = () => http.get(`/Client/all`)

const getMyClients = () => http.get(`/Client/my-clients`)

export default {
  getAll,
  getMyClients
}
